import omitBy from 'lodash/omitBy';

import type { DataLayer } from '../DataLayer';

const isFalseyButNotBooleanOrZero = (value: any): boolean =>
  typeof value !== 'boolean' && value !== 0 && !value;

const isEmptyArray = (value: any): boolean => {
  if (Array.isArray(value)) {
    const filtered = value.filter((x: Record<string, any>) => x);
    return Boolean(filtered.length === 0);
  }
  return false;
};

export const filterBlanks = (dataLayer: DataLayer): DataLayer =>
  omitBy(
    dataLayer,
    (value) => isFalseyButNotBooleanOrZero(value) || isEmptyArray(value),
  );
